import { Icon, Modal, Typography } from "@drone-js/core";
import { VStack } from "apps/commons/components/Stack";
import { substitute } from "apps/commons/functions/substitute";
import { usePropertySelectionViewModelValue } from "apps/propertySelection/propertySelectionViewModelAtom";
import type { ExtendedScrapingErrorResponseErrorTypeEnum } from "libs/codegen/property-onboarding";
import { memo } from "react";
import { useNavigate, useParams } from "router";
import { scrapingErrorResponseMapper } from "../scrapingErrorResponseMapper";

interface Props {
    errorType: ExtendedScrapingErrorResponseErrorTypeEnum;
    open: boolean;
    onClose: () => void;
}

export const NotFoundModal = memo<Props>(({ errorType, open, onClose }) => {
    const {
        inputUrlCms: {
            startListingAction,
            dismissAction,
            couldNotFindPropertyOnPlatform,
            airbnbPlatformName,
            bookingComPlatformName,
            propertyNotShowingUpOnPlatformInfo,
        },
    } = usePropertySelectionViewModelValue();
    const navigate = useNavigate();
    const { lang } = useParams("/:lang/list-my-property/get-started/automatic");

    const handleStartListing = () => {
        navigate("/:lang/list-my-property/get-started/manual", {
            params: {
                lang,
            },
        });
    };

    return (
        <Modal
            size="m"
            visible={open}
            onClose={onClose}
            title={
                (
                    <VStack gap="16">
                        <Icon id="fill.symbol.triangle-exclamation" color="feedback.urgent" size="48" />
                        <Typography variant="heading-l" textColor="base.default">
                            {substitute(couldNotFindPropertyOnPlatform, {
                                0:
                                    errorType === scrapingErrorResponseMapper.AirbnbPropertyNotFound
                                        ? airbnbPlatformName
                                        : bookingComPlatformName,
                            })}
                        </Typography>
                    </VStack>
                ) as unknown as string
            }
            description={
                substitute(propertyNotShowingUpOnPlatformInfo, {
                    0:
                        errorType === scrapingErrorResponseMapper.AirbnbPropertyNotFound
                            ? airbnbPlatformName
                            : bookingComPlatformName,
                }) as unknown as string
            }
            actions={[
                {
                    actionType: "button",
                    variant: "label",
                    hierarchy: "primary",
                    label: startListingAction,
                    onClick: handleStartListing,
                },
                {
                    actionType: "button",
                    variant: "label",
                    hierarchy: "secondary",
                    label: dismissAction,
                    onClick: onClose,
                },
            ]}
        />
    );
});
